import { Component, inject } from '@angular/core';
import { AccountService } from '../../services/account/account.service';
import { Router } from '@angular/router';
import { FormatService } from '../../services/format/format.service';
import { StorageService } from '../../services/storage/storage.service';

@Component({
  selector: 'app-enter-tiktok-complete',
  standalone: true,
  imports: [],
  templateUrl: './enter-tiktok-complete.component.html',
  styleUrl: './enter-tiktok-complete.component.scss'
})
export class EnterTiktokCompleteComponent {

  accountService: AccountService = inject(AccountService);
  formatService: FormatService = inject(FormatService);
  storageService: StorageService = inject(StorageService);
  router: Router = inject(Router);
  tiktokAccount: any | undefined;

  ngOnInit() {
    console.log('Enter TikTok complete ---->');
    console.log('Enter TikTok account: ', this.accountService.enterTiktok);

    this.tiktokAccount = this.accountService.enterTiktok;
  }

  exitBrowser() {
    console.log('Exit browser');
    window.close();
  }

  connectAnotherAccount() {
    console.log('Connect another account');
    const businessId = this.storageService.get('businessId');
    const externalId = this.storageService.get('externalId');
    this.router.navigate([`/connect/${externalId}/${businessId}`]);
  }
}
